/* ANGE Projects — Custom cart drawer enhancements
   Handles "Wears well with" quick-add from within the cart drawer, and
   sets the free-shipping progress bar's fill width.

   Note on the shipping bar: the fill width is applied via the JS
   `.style.width` CSSOM API (NOT an inline `style=""` attribute or a
   `<style>` tag written into the Liquid markup). This site appears to
   block inline styles written in HTML at parse time, which is why those
   two approaches silently did nothing. Direct DOM style mutation via
   `.style.width = ...` isn't inline HTML, so it isn't affected. Because
   the cart drawer's HTML gets replaced wholesale on every cart update
   (AJAX innerHTML swap), a MutationObserver re-applies the width from
   the fresh `data-progress` attribute every time that happens.

   Fix (Ange): the recommendation row wrapper in the markup uses the class
   `cart-drawer__carousel-item`, not `cart-drawer__recommendation` — the
   selectors below were updated to match the real markup so the size
   dropdown and Add button can find each other. The size-select `change`
   listener is now registered in the CAPTURE phase and calls
   stopPropagation() so it never reaches the native cart-drawer-items
   change handler (assets/cart.js), which was misreading the recommendation
   size selection as a cart quantity update and throwing the generic
   "There was an error while updating your cart" message.

   ANGE: size buttons ("Wears well with", snippets/cart-drawer-recommendation-list.liquid).
   Tapping a size button sets the row's hidden size select to that size and presses the
   row's hidden Add button, so the add-to-cart logic below is reused unchanged. */
(function () {
  function applyShippingProgress() {
    document.querySelectorAll('[data-shipping-progress-fill]').forEach(function (el) {
      var value = parseFloat(el.getAttribute('data-progress'));
      if (isNaN(value)) value = 0;
      if (value < 0) value = 0;
      if (value > 100) value = 100;
      el.style.width = value + '%';
    });
  }

  applyShippingProgress();

  var cartDrawerRoot = document.getElementById('CartDrawer');
  if (cartDrawerRoot) {
    new MutationObserver(applyShippingProgress).observe(cartDrawerRoot, {
      childList: true,
      subtree: true,
    });
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function refreshCartDrawer() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(cartUrl + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var cartDrawerEl = document.getElementById('CartDrawer');
        var bubbleEl = document.getElementById('cart-icon-bubble');

        if (cartDrawerEl && sections['cart-drawer']) {
          cartDrawerEl.innerHTML = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
        }
        if (bubbleEl && sections['cart-icon-bubble']) {
          bubbleEl.innerHTML = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          drawer.classList.add('animate', 'active');
        }

        applyShippingProgress();
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  // Capture phase + stopPropagation: prevents this change event from ever
  // reaching the native cart-drawer-items change handler further down the
  // bubble path.
  document.addEventListener(
    'change',
    function (event) {
      var select = event.target.closest('.cart-drawer__recommendation-variant');
      if (!select) return;
      event.stopPropagation();

      var row = select.closest('.cart-drawer__carousel-item');
      if (!row) return;

      var button = row.querySelector('.cart-drawer__recommendation-add');
      var selectedOption = select.options[select.selectedIndex];
      if (!button || !selectedOption) return;

      if (selectedOption.dataset.available === 'false') {
        button.setAttribute('disabled', 'disabled');
      } else {
        button.removeAttribute('disabled');
      }
    },
    true
  );

  // ANGE: one tap on a size button adds that size.
  document.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('.ange-cu__size');
    if (!sizeBtn || sizeBtn.disabled) return;
    event.preventDefault();

    var row = sizeBtn.closest('.cart-drawer__carousel-item');
    if (!row) return;
    var select = row.querySelector('.cart-drawer__recommendation-variant');
    var addBtn = row.querySelector('.cart-drawer__recommendation-add');
    if (!select || !addBtn) return;

    select.value = sizeBtn.dataset.variantId;
    addBtn.removeAttribute('disabled');
    row.querySelectorAll('.ange-cu__size').forEach(function (b) {
      b.classList.remove('is-loading');
    });
    sizeBtn.classList.add('is-loading');
    addBtn.click();
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-drawer__recommendation-add');
    if (!button) return;
    event.preventDefault();

    var row = button.closest('.cart-drawer__carousel-item');
    var select = row ? row.querySelector('.cart-drawer__recommendation-variant') : null;
    var variantId = select ? select.value : button.dataset.variantId;
    if (!variantId) return;

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var originalText = button.textContent;

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');
    button.textContent = '...';

    function resetRowLoading() {
      if (!row) return;
      row.querySelectorAll('.ange-cu__size.is-loading').forEach(function (b) {
        b.classList.remove('is-loading');
      });
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          button.textContent = originalText;
          button.classList.remove('is-loading');
          button.removeAttribute('disabled');
          resetRowLoading();
          console.error(data.description || data.message);
          return;
        }
        button.textContent = originalText;
        refreshCartDrawer();
      })
      .catch(function (e) {
        console.error(e);
        button.textContent = originalText;
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
        resetRowLoading();
      });
  });
})();
